/*
 * @Descripttion: 设置 飞机 视锥体
 * @version:
 * @Author: szj
 * @Date: 2023-06-25 13:39:45
 * @LastEditors: szj
 * @LastEditTime: 2025-11-12 17:13:00
 */
class CreateFrustum {
  position: any;
  orientation: any;
  fov: any;
  near: any;
  far: any;
  aspectRatio: any;
  viewer: any;
  frustumPrimitive: any;
  outlinePrimitive: any;
  axisPrimitive: any; // 视锥体主轴线
  videoPrimitive: any; // 视频投影
  lastUpdateTime: any; //
  updateInterval: any; // 200ms更新一次，而不是每帧更新
  enabled: any; // 是否启用更新
  reusableVertices: any; //
  constructor(options: any) {
    this.position = options.position;
    this.orientation = options.orientation;
    this.fov = options.fov || 0.7;
    this.near = options.near || 0.5;
    this.far = options.far || 300;
    this.aspectRatio = options.aspectRatio;
    this.viewer = options.viewer;
    // 🎯 新增：更新控制
    this.lastUpdateTime = 0;
    this.updateInterval = 200; // 200ms更新一次，而不是每帧更新
    this.enabled = true; // 是否启用更新
    this.reusableVertices = []; //
    this.add();
  }
  // 更新视锥体的姿态
  update(orientation: any) {
    this.orientation = orientation;
    this.add();
  }
  updateFov(fov: any) {
    this.fov = fov;
    this.add();
  }
  updatePosition(position: any, orientation: any) {
    this.throttledUpdatePosition(position, orientation);
  }
  updatePositions(position: any, orientation: any) {
    this.position = position;
    this.orientation = orientation;
    this.add();
    // this.addVideo("videoMapBox");
  }
  updateFar(position: any, orientation: any, far: any) {
    this.position = position;
    this.orientation = orientation;
    this.far = far;
    this.add();
  }
  // 创建视锥体和轮廓线
  add() {
    this.clear();
    this.addFrustum();
    this.addOutline();
    this.addCenterLine(); //  添加绘制中心线的方法调用
  }

  // 清除视锥体和轮廓线
  clear() {
    this.clearFrustum();
    this.clearOutline();
    this.clearCenterLine(); //  添加清除中心线的方法调用
    this.clearVideo();
  }
  //  清除中心线的方法
  clearCenterLine() {
    if (this.axisPrimitive) {
      this.viewer.scene.primitives.remove(this.axisPrimitive);
      this.axisPrimitive = null;
    }
  }
  //  清除 视频投影 的方法
  clearVideo() {
    // if (this.videoPrimitive) {
    //   this.viewer.entities.remove(this.videoPrimitive);
    //   this.videoPrimitive = null;
    // }
    if (this.videoPrimitive) {
      this.viewer.scene.primitives.remove(this.videoPrimitive);
      this.videoPrimitive = null;
    }
  }
  // 清除视锥体
  clearFrustum() {
    if (this.frustumPrimitive) {
      this.viewer.scene.primitives.remove(this.frustumPrimitive);
      this.frustumPrimitive = null;
    }
  }

  // 清除轮廓线
  clearOutline() {
    if (this.outlinePrimitive) {
      this.viewer.scene.primitives.remove(this.outlinePrimitive);
      this.outlinePrimitive = null;
    }
  }
  // 销毁时移除事件监听
  destroy() {
    this.clear();
  }
  // 🎯 修改：添加节流更新方法
  throttledUpdatePosition(position: any, orientation: any) {
    const now = Date.now();
    if (now - this.lastUpdateTime < this.updateInterval) {
      return; // 跳过这次更新
    }

    this.lastUpdateTime = now;
    this.updatePositions(position, orientation);
  }
  // 创建视锥体
  addFrustum() {
    this.clearFrustum();
    const vertices = this.calculateFrustumVertices();
    const indices = [
      0,
      1,
      2,
      0,
      2,
      3, // near plane
      4,
      5,
      6,
      4,
      6,
      7, // far plane
      0,
      1,
      5,
      0,
      5,
      4, // left plane
      1,
      2,
      6,
      1,
      6,
      5, // top plane
      2,
      3,
      7,
      2,
      7,
      6, // right plane
      3,
      0,
      4,
      3,
      4,
      7, // bottom plane
    ];
    const geometry = new Cesium.Geometry({
      attributes: {
        position: new Cesium.GeometryAttribute({
          componentDatatype: Cesium.ComponentDatatype.DOUBLE,
          componentsPerAttribute: 3,
          values: vertices.flatMap((v) => [v.x, v.y, v.z]),
        }),
      },
      indices: indices,
      primitiveType: Cesium.PrimitiveType.TRIANGLES,
      boundingSphere: Cesium.BoundingSphere.fromVertices(
        vertices.flatMap((v) => [v.x, v.y, v.z])
      ),
    });
    const instance = new Cesium.GeometryInstance({
      geometry: geometry,
      attributes: {
        color: Cesium.ColorGeometryInstanceAttribute.fromColor(
          new Cesium.Color.fromCssColorString("rgba(0,213,144, 0.2)")
        ),
      },
    });
    const primitive = new Cesium.Primitive({
      geometryInstances: instance,
      appearance: new Cesium.PerInstanceColorAppearance({
        closed: true,
        flat: true,
      }),
      asynchronous: false,
    });
    this.frustumPrimitive = this.viewer.scene.primitives.add(primitive);
  }

  // 创建轮廓线
  addOutline() {
    this.clearOutline();
    const vertices = this.calculateFrustumVertices();
    const indices = [
      0,
      1,
      1,
      2,
      2,
      3,
      3,
      0, // near plane
      4,
      5,
      5,
      6,
      6,
      7,
      7,
      4, // far plane
      0,
      4,
      1,
      5,
      2,
      6,
      3,
      7, // connecting lines
    ];
    const geometry = new Cesium.Geometry({
      attributes: {
        position: new Cesium.GeometryAttribute({
          componentDatatype: Cesium.ComponentDatatype.DOUBLE,
          componentsPerAttribute: 3,
          values: vertices.flatMap((v) => [v.x, v.y, v.z]),
        }),
      },
      indices: indices,
      primitiveType: Cesium.PrimitiveType.LINES,
      boundingSphere: Cesium.BoundingSphere.fromVertices(
        vertices.flatMap((v) => [v.x, v.y, v.z])
      ),
    });
    const instance = new Cesium.GeometryInstance({
      geometry: geometry,
      attributes: {
        color: Cesium.ColorGeometryInstanceAttribute.fromColor(
          new Cesium.Color.fromCssColorString("rgba(0,213,144, 0.8)")
        ),
      },
    });
    const primitive = new Cesium.Primitive({
      geometryInstances: instance,
      appearance: new Cesium.PerInstanceColorAppearance({
        closed: true,
        flat: true,
      }),
      asynchronous: false,
    });
    this.outlinePrimitive = this.viewer.scene.primitives.add(primitive);
  }
  //  绘制中心线的方法
  addCenterLine() {
    const vertices = this.calculateFrustumVertices();
    // // 计算近平面和远平面中心点
    const nearCenter = this.calculatePlaneCenter(vertices.slice(0, 4));
    const farCenter = this.calculatePlaneCenter(vertices.slice(4, 8));
    // // 创建主轴（从近平面中心到远平面中心）
    const axisPrimitive = new Cesium.PolylineCollection();
    const uniqueId = `centerLine_${Date.now()}`;
    axisPrimitive.id = uniqueId;
    axisPrimitive.add({
      positions: [nearCenter, farCenter],
      width: 2,
      material: Cesium.Material.fromType("PolylineDash", {
        color: Cesium.Color.fromCssColorString("rgba(0, 213, 144, 0.8)"), // 设置主轴线颜色,
        dashPattern: 0xff00ff, // 虚线模式
      }),
    });
    // // 添加到场景
    this.axisPrimitive = this.viewer.scene.primitives.add(axisPrimitive);
  }

  // 绘制视频投影
  addVideo(videoDom: any) {
    // const hierarchy = this.calcFarVertices();
    // console.log("Video hierarchy:", hierarchy);

    // // 清理已存在的视频元素
    // if (this.videoPrimitive) {
    //   this.viewer.entities.remove(this.videoPrimitive);
    //   this.videoPrimitive = null;
    // }
    // let video_dom = document.getElementById(videoDom) as any;

    // // 添加加载事件监听器以确保视频加载后再应用材质
    // video_dom.addEventListener("loadedmetadata", () => {
    //   // 创建视频材质
    //   const videoMaterial = new Cesium.ImageMaterialProperty({
    //     image: video_dom,
    //     transparent: true,
    //     repeat: new Cesium.Cartesian2(1.0, 1.0), // 确保视频不被拉伸
    //   });

    //   // 创建视频多边形实体
    //   this.videoPrimitive = this.viewer.entities.add({
    //     polygon: {
    //       hierarchy: new Cesium.PolygonHierarchy(hierarchy),
    //       material: videoMaterial,
    //       clampToGround: true,
    //       // 设置多边形的高度参考和偏移，确保它正确地放置在远平面上
    //       heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
    //       height: 0,
    //     },
    //   });
    // });

    // // 添加错误事件监听
    // video_dom.addEventListener("error", (event: any) => {
    //   console.error("Video error:", event);
    // });
    this.clearVideo();
    // 获取视锥体顶点
    const vertices = this.calculateFrustumVertices();

    // 只使用远平面的四个顶点 (索引4-7)
    const farPlaneVertices = vertices.slice(4, 8);

    // 创建远平面的几何图形
    const geometry = new Cesium.Geometry({
      attributes: {
        position: new Cesium.GeometryAttribute({
          componentDatatype: Cesium.ComponentDatatype.DOUBLE,
          componentsPerAttribute: 3,
          values: farPlaneVertices.flatMap((v) => [v.x, v.y, v.z]),
        }),
        // 添加纹理坐标
        st: new Cesium.GeometryAttribute({
          componentDatatype: Cesium.ComponentDatatype.FLOAT,
          componentsPerAttribute: 2,
          values: [0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0],
        }),
      },
      // 远平面的三角形索引
      indices: [0, 1, 2, 0, 2, 3],
      primitiveType: Cesium.PrimitiveType.TRIANGLES,
      boundingSphere: Cesium.BoundingSphere.fromVertices(
        farPlaneVertices.flatMap((v) => [v.x, v.y, v.z])
      ),
    });

    const instance = new Cesium.GeometryInstance({
      geometry: geometry,
    });

    const primitive = new Cesium.Primitive({
      geometryInstances: [instance],
      appearance: this.createAppearance(videoDom),
      asynchronous: false,
    });
    this.videoPrimitive = this.viewer.scene.primitives.add(primitive);
  }
  createAppearance(videoDom: any) {
    let video_dom = document.getElementById(videoDom) as any;
    // video_dom.play();
    let source = `czm_material czm_getMaterial(czm_materialInput materialInput)
    {
        czm_material material = czm_getDefaultMaterial(materialInput);
        vec2 st = materialInput.st;
        vec4 colorImage = texture2D(image, vec2(st.s, st.t));
        vec4 maskImage = texture2D(tmask, vec2(st.s, st.t));
        material.alpha = colorImage.a * color.a*maskImage.r;
        material.diffuse = colorImage.rgb*color.rgb;
        return material;
    }`;
    let material = new Cesium.Material({
      fabric: {
        type: "custome_1",
        uniforms: {
          color: new Cesium.Color(1.0, 1.0, 1.0, 1.0),
          image: "",
          tmask: "",
        },
        source: source,
      },
    });
    material.uniforms.image = video_dom;
    let appearance = new Cesium.EllipsoidSurfaceAppearance({
      material: material,
      flat: true,
      renderState: {
        cull: {
          enabled: false,
        },
        depthTest: {
          enabled: false,
        },
      },
    });
    return appearance;
  }

  // 计算平面四个顶点中心坐标的方法
  calculatePlaneCenter(points: any) {
    const sum = points.reduce(
      (acc: any, point: any) =>
        Cesium.Cartesian3.add(acc, point, new Cesium.Cartesian3()),
      new Cesium.Cartesian3()
    );
    return Cesium.Cartesian3.multiplyByScalar(
      sum,
      1 / points.length,
      new Cesium.Cartesian3()
    );
  }
  calculateFrustumVertices() {
    // 重用对象而不是创建新对象
    // if (!this.reusableVertices) {
    //   this.reusableVertices = [];
    //   for (let i = 0; i < 8; i++) {
    //     this.reusableVertices.push(new Cesium.Cartesian3());
    //   }
    // }
    const { fov, aspectRatio, near, far, position, orientation } = this;
    const tanFov = Math.tan(fov / 2);

    // 本地坐标系顶点计算
    const nearHeight = 2 * tanFov * near;
    const nearWidth = nearHeight * aspectRatio;
    const farHeight = 2 * tanFov * far;
    const farWidth = farHeight * aspectRatio;

    const verticesLocal = [
      new Cesium.Cartesian3(-nearWidth / 2, nearHeight / 2, -near), // 近平面左上
      new Cesium.Cartesian3(nearWidth / 2, nearHeight / 2, -near), // 近平面右上
      new Cesium.Cartesian3(nearWidth / 2, -nearHeight / 2, -near), // 近平面右下
      new Cesium.Cartesian3(-nearWidth / 2, -nearHeight / 2, -near), // 近平面左下
      new Cesium.Cartesian3(-farWidth / 2, farHeight / 2, -far * 1.0), // 远平面左上
      new Cesium.Cartesian3(farWidth / 2, farHeight / 2, -far * 1.0), // 远平面右上
      new Cesium.Cartesian3(farWidth / 2, -farHeight / 2, -far * 1.0), // 远平面右下
      new Cesium.Cartesian3(-farWidth / 2, -farHeight / 2, -far * 1.0), // 远平面左下
    ];

    // 应用位置和方向变换到世界坐标
    const rotationMatrix = Cesium.Matrix3.fromQuaternion(orientation);
    const transform = Cesium.Matrix4.fromRotationTranslation(
      rotationMatrix,
      position
    );
    return verticesLocal.map((v) =>
      Cesium.Matrix4.multiplyByPoint(transform, v, new Cesium.Cartesian3())
    );
    // verticesLocal.forEach((v, index) => {
    //   Cesium.Matrix4.multiplyByPoint(
    //     transform,
    //     v,
    //     this.reusableVertices[index]
    //   );
    // });

    // return this.reusableVertices;
  }
  // 创建远平面的四个经纬度
  calcFarVertices() {
    const { fov, aspectRatio, far, position, orientation } = this;
    const tanFov = Math.tan(fov / 2);

    // 本地坐标系顶点计算
    const farHeight = 2 * tanFov * far;
    const farWidth = farHeight * aspectRatio;

    const verticesLocal = [
      new Cesium.Cartesian3(-farWidth / 2, farHeight / 2, -far * 1.0), // 远平面左上
      new Cesium.Cartesian3(farWidth / 2, farHeight / 2, -far * 1.0), // 远平面右上
      new Cesium.Cartesian3(farWidth / 2, -farHeight / 2, -far * 1.0), // 远平面右下
      new Cesium.Cartesian3(-farWidth / 2, -farHeight / 2, -far * 1.0), // 远平面左下
    ];

    // 应用位置和方向变换到世界坐标
    const rotationMatrix = Cesium.Matrix3.fromQuaternion(orientation);
    const transform = Cesium.Matrix4.fromRotationTranslation(
      rotationMatrix,
      position
    );
    let arr = verticesLocal.map((v) =>
      Cesium.Matrix4.multiplyByPoint(transform, v, new Cesium.Cartesian3())
    );
    return arr;
  }
  // 笛卡尔坐标 xyz 转为地理坐标 obj={x,y,z}
  xyzToLngLat(obj: any) {
    let x = obj.x;
    let y = obj.y;
    let z = obj.z;
    let xyz = new Cesium.Cartesian3(x, y, z); // xyz 坐标
    // 将 xyz 坐标转换为地理坐标
    let cartographic = Cesium.Cartographic.fromCartesian(xyz);
    // 提取经纬度和高度
    let longitude = Cesium.Math.toDegrees(cartographic.longitude).toFixed(8); // 经度（单位：度）
    let latitude = Cesium.Math.toDegrees(cartographic.latitude).toFixed(8); // 纬度（单位：度）
    let height = cartographic.height.toFixed(2); // 高度（单位：米）
    return [longitude, latitude, height];
  }
}
export default CreateFrustum;
